import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { List, X } from "@phosphor-icons/react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/jobs", label: "Careers" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const { user, logout } = useAuth();
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-50 glass-header">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <img
            src="/twinstars-logo.png"
            alt="Twinstars Plaza"
            className="h-14 w-auto object-contain"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-link-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm tracking-tight font-medium relative ${isActive ? "text-black" : "text-black/60 hover:text-black"}`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              <Link to={user.role === "admin" ? "/admin" : "/dashboard"} className="btn-outline" data-testid="nav-dashboard-link">
                {user.role === "admin" ? "Admin" : "Dashboard"}
              </Link>
              <button onClick={handleLogout} className="btn-ghost" data-testid="nav-logout">Sign out</button>
            </>
          ) : (
            <>
              <Link to="/login" className="btn-ghost" data-testid="nav-login">Sign in</Link>
              <Link to="/register" className="btn-primary" data-testid="nav-register">Get started</Link>
            </>
          )}
        </div>

        <button className="md:hidden" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Toggle menu">
          {open ? <X size={24} /> : <List size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-black/10 bg-white">
          <div className="px-6 py-4 flex flex-col gap-3">
            {NAV.map((n) => (
              <Link key={n.to} to={n.to} className="text-sm font-medium" onClick={() => setOpen(false)} data-testid={`nav-mobile-${n.label.toLowerCase()}`}>
                {n.label}
              </Link>
            ))}
            <div className="divider-thick my-2" />
            {user ? (
              <>
                <Link
                  to={user.role === "admin" ? "/admin" : user.role === "staff" ? "/staff" : "/dashboard"}
                  className="btn-outline w-full"
                  onClick={() => setOpen(false)}
                >
                  {user.role === "admin" ? "Admin" : user.role === "staff" ? "Staff" : "Dashboard"}
                </Link>
                <button onClick={handleLogout} className="btn-ghost w-full">Sign out</button>
              </>
            ) : (
              <>
                <Link to="/login" className="btn-outline w-full" onClick={() => setOpen(false)}>Sign in</Link>
                <Link to="/register" className="btn-primary w-full" onClick={() => setOpen(false)}>Get started</Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
